import { Permission, QuoteResponse } from "@forgepoint/shared";
import { useCanEditOwned } from "@/store/authStore";

/**
 * Resolves owner-scoped edit access for an existing quote: granted by
 * `quotes.edit.all`, or by `quotes.edit.own` when the user owns it — as its
 * sales rep, or as an owner of the associated opportunity (its sales rep or an
 * estimator). This is permission alone, independent of whether the quote is
 * currently editable, so it still holds once a quote is finalized or archived.
 */
export function useCanEditQuote(quote?: QuoteResponse | null): boolean {
  return useCanEditOwned(
    Permission.QUOTES_EDIT_ALL,
    Permission.QUOTES_EDIT_OWN,
    [
      quote?.salesRepUserId,
      quote?.opportunity?.salesRepUserId,
      ...(quote?.opportunity?.estimatorUserIds ?? []),
    ],
  );
}
